import styled from "styled-components";

export const PaymentWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  height: 100vh;
  width: 100vw;
  position: fixed;
  top: 0;
  left: 0;
  flex-direction: column;
`;

export const RedirectionText = styled.div`
  color: #451999;
  text-align: center;
  font-size: 18px;
  font-weight: 600;
  line-height: 28px; 
  letter-spacing: -0.1px;
`;
